import { SiteBunnyError, toSiteBunnyError } from "../../error";
import { useQuery } from "@tanstack/react-query";
import invitationRepository from "../../repository/InvitationRepository";
import { MemberInvitation } from "../../model/invitation";
import {User} from "../../model/user";

const getData = async (email: string) => {
    try {
        const { data } = await invitationRepository.find_with_email(email);
        return data.result;
    } catch (e) {
        throw toSiteBunnyError(e);
    }
}

// user id 기반으로 초대된 채널 조회
const useMemberInvitations = (profile: User | undefined) => {
    return useQuery<MemberInvitation[], SiteBunnyError>({
        queryKey: ['userMemberInvitations', profile?.email],
        queryFn: async () => getData(profile!.email),
        enabled: !!profile,
        retry: false,
        suspense: false,
        useErrorBoundary: false
    })
}

export default useMemberInvitations;
